import { render, staticRenderFns } from "./StepDesc.vue?vue&type=template&id=19245de0&lang=pug&"
import script from "./StepDesc.vue?vue&type=script&lang=js&"
export * from "./StepDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports